/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import gql from "graphql-tag.macro";

const gqlSaveUserContextFeatureSelection = gql`
  mutation UpdateUserContextFeatureFavourites($v3UserId:ID!,$v3ProjectId:ID!,$featureFavourites:[String]) {
    updateUserContextFeatureFavourites(v3UserId:$v3UserId, v3ProjectId:$v3ProjectId, featureFavourites:$featureFavourites){
      userId
      position
      level
      featureFavourites{
        name
        projectId
        created
      }
    }
  }
`;

const gqlGetUserContext = gql`
  query getUserContext($v3ProjectId:ID!,$v3UserId:ID!) {
    userContext(v3ProjectId: $v3ProjectId, v3UserId: $v3UserId) {
      userId
      position
      level
      featureFavourites {
        name
        projectId
        created
      }
    }
  }

`;

export const saveUserContextFeatureFavourites = async ({ formValues }, { client }) => {
  const featureFavourites = Object.keys(formValues).filter(key => formValues[key] === true) || [];

  const {
    data: { updateUserContextFeatureFavourites },
  } = await client.mutate({
    mutation: gqlSaveUserContextFeatureSelection,
    variables: {
      v3UserId: window.app.Duchess.currentUser._id,
      v3ProjectId: window.app.Duchess.currentProject._id,
      featureFavourites
    },
  });

  return updateUserContextFeatureFavourites?.featureFavourites || [];
};

export const getUserContext = async ({ client }) => {
  const {
    data: { userContext },
  } = await client.query({
    query: gqlGetUserContext,
    variables: {
      v3UserId: window.app.Duchess.currentUser._id,
      v3ProjectId: window.app.Duchess.currentProject._id
    },
    fetchPolicy: "no-cache"
  });

  return userContext?.featureFavourites || [];
};
